import { toast } from 'sonner';
import { getEdgeFunctionErrorMessage } from './edgeFunction';

/**
 * Shows a toast error with the edge function name included
 */
export function toastEdgeFunctionError(
  functionName: string, 
  error: any, 
  prefix?: string
): string {
  const message = getEdgeFunctionErrorMessage(error, functionName);
  
  // If we got a clean user-facing message (not the generic fallback), show it directly
  const edgeFnPrefix = `Edge Function: ${functionName} - `;
  const cleanMessage = message.startsWith(edgeFnPrefix) 
    ? message.slice(edgeFnPrefix.length) 
    : message;
  
  // Only add the prefix if the clean message is still generic
  const isGeneric = cleanMessage === 'returned a non-2xx status code' || !cleanMessage;
  const fullMessage = prefix && isGeneric ? `${prefix}. Please try again.` : cleanMessage;
  
  toast.error(fullMessage);
  return message;
}